/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Provider_Businesscentral1Inputs */



/**
* | output |
* | --- |
* | "Business Central" |
*
* @param {Spaces_Provider_Businesscentral1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const spaces_provider_businesscentral1 = /** @type {((inputs?: Spaces_Provider_Businesscentral1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Provider_Businesscentral1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Business Central")
	return /** @type {LocalizedString} */ ("Business Central")
});
export { spaces_provider_businesscentral1 as "spaces_provider_businessCentral" }